import React from 'react';
import { Box, Modal, Card, CardContent, CardHeader, Stack, Button, TextField, Radio, RadioGroup, FormControlLabel, Alert } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { senMessageWithUrlForTransaction } from '../../../../../../services/request';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const SendTpayLinkModal = ({ open, handleClose }) => {
  const { order } = useSelector(state => state.orderData);
  const { mutate } = useMutation(senMessageWithUrlForTransaction);
  const [amount, setAmount] = React.useState('');
  const [leftToPay, setLeftToPay] = React.useState('false');

  const handleChange = e => setAmount(e.target.value);

  const handleSubmit = async () => {
    let data = {};
    if (amount !== '' && leftToPay == 'false') {
      data = {
        order_id: order.id,
        to_pay: amount,
        contract_number: order.agreement_number === '' ? null : order.agreement_number,
        email: order.guardian_correspondence_email,
        name: order.guardian_name,
        purchaser_id: order.guardian,
        participant: order.participant_name
      };
    } else {
      data = {
        order_id: order.id,
        to_pay: false,
        contract_number: order.agreement_number === '' ? null : order.agreement_number,
        email: order.guardian_correspondence_email,
        name: order.guardian_name,
        purchaser_id: order.guardian,
        participant: order.participant_name
      };
    }

    const { error, payload } = await mutate(data);

    if (!error) {
      toast.success('Wiadomość została wysłana');
      handleClose();
    } else {
      toast.error('Wystąpił błąd');
    }

  };

  return (<>
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style }}>
        <CardHeader title="Wyślij link do płatności"/>
        <CardContent sx={{ flexGrow: 1, width: '400px' }}>
          <RadioGroup
            defaultValue={leftToPay}
            value={leftToPay}
            onChange={e => setLeftToPay(e.target.value)}
          >
            <Stack direction="row" justifyContent="space-between">
              <Stack direction="column">
                <FormControlLabel value={false} control={<Radio />} label="Kwota" />
                <FormControlLabel value={true} control={<Radio />} label="Pozostało do zapłaty" />
              </Stack>
            </Stack>
          </RadioGroup>
          {leftToPay == 'true' ? null
            : <TextField
              label={'Kwota (zł)'}
              fullWidth
              type="number"
              onChange={handleChange}
              value={amount}
            />
          }
          <Box height={40} />
          {
            order.left_to_pay <= 0 && leftToPay === 'true'
              ? <>
                <Alert severity="info">Wszystko zostało opłacone</Alert>
                <Box height={40} />
              </>
              : null
          }

          <Stack flexDirection="row" justifyContent="space-around">
            <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>anuluj</Button>
            <Button sx={{ flexGrow: 0.4 }} variant="contained" disabled={order.left_to_pay <= 0 && leftToPay === 'true'} onClick={handleSubmit}>wyślij</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  </>);
};

export default SendTpayLinkModal;
